const PS_EVENT_NAME = 'postscriptPopup';

window.addEventListener(PS_EVENT_NAME, function(event) {
  const data = event.detail;
  
  //Safety check to ensure Facebook Pixel is loaded
  if (typeof fbq === 'undefined') return;
  

  switch (data.type) {
    case 'impression':
      fbq('trackCustom', 'Email Popup Triggered', {
        popup_name: data.popupName,
        popup_id: data.popupId
      });
      break;

    case 'formSubmit':
      // ONLY fire if 'values' exists and contains an 'email'
      if (data.values && data.values.email) {        
        // No form values: they hold the plaintext email and phone, which never go to Meta.
        fbq('trackCustom', 'Email Popup Submitted', {
          popup_name: data.popupName,
          popup_id: data.popupId
        });
      } else {
        console.log("formSubmit skipped - no email provided");
      }
      break;
    // case 'subscriberCreated':
    //   fbq('trackCustom', 'Email Popup Subscribed Created', {
    //     popup_name: data.popupName,
    //     popup_id: data.popupId,
    //     values: data.values
    //   });
    //   break;
  }
});

// Send Postscript popup events to Amplitude (window.ryzeTrack, snippets/amplitude-track.liquid)
// under the optin_* names headless pages use (RYZE-headless-offers-v2
// src/shell/header.ts setupPostscriptSDKListeners). Events land on the pixel's
// device/session, so they group by the [Experiment] <id> user property set at exposure.
// Context props mirror the headless Amplitude tracker (src/trackers/amplitude.ts), read
// from the same proxy-injected window.rz.
function psOptinContext() {
  const rz = window.rz || {};
  const props = {
    environment: 'shopify',
    page_url: location.href,
    page_path: location.pathname,
    page_title: document.title,
    referrer: document.referrer
  };
  if (rz.geo) {
    props.country = rz.geo.country;
    props.state = rz.geo.state;
    props.city = rz.geo.city;
  }
  if (rz.experience) {
    props.experience_type = rz.experience.type;
    props.experience_name = rz.experience.name;
    props.experience_path = rz.experience.path;
    props.experience_route_pattern = rz.experience.routePattern;
    props.is_test = rz.experience.isTest;
    props.current_experience_name = rz.experience.name;
  }
  if (rz.splitTest) {
    props.split_test_decision = rz.splitTest.decision;
    props.experiment_id = rz.splitTest.experimentId;
    props.variant_id = rz.splitTest.variantId;
  }
  if (rz.visitor) {
    props.visitor_type = rz.visitor.type;
    props.is_new_visitor = rz.visitor.type === 'new';
    if (rz.visitor.firstVisit) props.first_visit_at = new Date(rz.visitor.firstVisit).toISOString();
  }
  return props;
}

window.addEventListener(PS_EVENT_NAME, function(event) {
  const data = event.detail || {};
  if (!window.ryzeTrack || !data.type) return;

  const base = Object.assign(psOptinContext(), { popup_id: data.popupId, popup_name: data.popupName, source: 'postscript' });
  const values = data.values || {};

  switch (data.type) {
    case 'impression':
      // Milliseconds from navigation start until Postscript showed the popup.
      ryzeTrack('optin_viewed', Object.assign({ is_reopen: !!data.isReopen, time_to_show_ms: Math.round(performance.now()) }, base));
      break;

    case 'formSubmit': {
      // Identify like headless (amplitude.setUserId(email)) and the checkout pixel
      // (lowercased email as user id), so the visitor stops being anonymous at opt-in.
      const email = values.email && String(values.email).trim().toLowerCase();
      const user = email ? { userId: email, userProperties: { email: email, accepts_marketing: true } } : null;
      if (user && values.phone) user.userProperties.phone = values.phone;
      if (values.email) ryzeTrack('optin_email_submitted', base, user);
      if (values.phone) ryzeTrack('optin_sms_submitted', base, user);
      break;
    }

    case 'close':
      ryzeTrack('optin_dismissed', Object.assign({ hard_close: !!data.hard }, base));
      break;

    case 'subscriberCreated':
      ryzeTrack('optin_success', Object.assign({
        subscriber_id: data.subscriberId,
        discount_code: data.discountCode,
        cashback_code: data.cashbackCode,
        auto_apply_offer: data.autoApplyOfferEnabled
      }, base));
      break;
  }
});

//window.postscript.popups.open("283c240f-67d2-4a5f-82cd-3d3b62bc697c");
